module.exports = __webpack_public_path__ + "static/img/yunsheng01.05e34e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yunsheng01.jpg
// module id = YJCt
// module chunks = 0